import { isNil, isPlainObject } from 'lodash';

import fromEntriesToObject from 'utils/converters/object/fromEntriesToObject.util';
import logger from 'utils/logger.util';

const L = logger('fromObjectToQueryString');

const filter = (object) => {
  if (isNil(object)) {
    return {};
  }

  // replace undefined and null with '' for the URL to not change semantics of the data it carries
  return fromEntriesToObject(Object.entries(object).map(([k, v]) => [k, isNil(v) ? '' : v]));
};

const fromObjectToQueryString = (params) => {
  try {
    if (!isPlainObject(params)) {
      return '';
    }

    return new URLSearchParams(filter(params)).toString();
  } catch (e) {
    L.warn('()', e);
    return '';
  }
};

// noinspection JSUnusedGlobalSymbols
export default fromObjectToQueryString;
